import type { JSX } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import type { Rect } from 'react-use-rect';
import { useRect } from 'react-use-rect';
import { textStyleMixin } from '../mixins';

export interface TextMeasureProps {
  children: ({ width }: { width: number }) => JSX.Element | void;
  text: string;
  textStyle: TextStyleValue;
}

export function TextMeasure({ text, children, textStyle }: TextMeasureProps) {
  const [bounds, setBounds] = useState<Rect>();
  const [ref] = useRect(setBounds, { resize: true });

  return (
    <>
      <TextMeasureComponent ref={ref} _textStyle={textStyle}>
        {text}
      </TextMeasureComponent>
      {bounds && children(bounds)}
    </>
  );
}

export const TextMeasureComponent = styled.span<{ _textStyle: TextStyleValue }>`
  ${textStyleMixin};
  position: absolute;
  z-index: -999;
  height: 0;
  overflow: hidden;
  white-space: pre;
`;
